import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ISitesResponse } from 'src/app/interfaces/Responses/ISitesResponse';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { LoginService } from 'src/app/services/security/login.service';

@Component({
  selector: 'neoris-incident-form',
  templateUrl: './incident-form.component.html',
  styleUrls: ['./incident-form.component.css']
})
export class IncidentFormComponent implements OnInit {
  private onLanChange:Subscription
  nombre:string=''
  arrayIncidentsTypes:any[] = []
  arrayCategorias:any[]=[]
  arrayTipoPersonal:any[]=[]
  arrayCausaRaiz:any[]=[]
  arraySistemaConsecuencias:any[] = []
  arrayPuesto:any[]=[]
  selectedDefault:string="0"
  loadLang:boolean=false
  incidentFormRequest:any={}
  incidentFormData:any={}
  ud: any={}
  formIncidentRequest:any={}
  private onClick:Subscription
  private unsubscribe$: Subject<any> = new Subject<any>();
  arraySites: any[] = []
  arrayEvidenceStatus:any[]=[]
  lang:string=''

  get folio(){
    return this.formIncident.get('invoice') as UntypedFormControl
  }

  get monitoreoAsesor(){
    return this.formIncident.get('monitoringAdvisor') as UntypedFormControl
  }

  get categoryId(){
    return this.formIncident.get('categoryId') as UntypedFormControl
  }

  get typeOfStaffId(){
    return this.formIncident.get('typeOfStaffId') as UntypedFormControl
  }

   get registrationDate(){
    return this.formIncident.get('registrationDate') as UntypedFormControl
  }
 


  get rootCauseId(){
    return this.formIncident.get('rootCauseId') as UntypedFormControl
  }

  get personName(){
    return this.formIncident.get('personName') as UntypedFormControl
  }

  get positionId(){
    return this.formIncident.get('positionId') as UntypedFormControl
  }

  get consequencesSystemId(){
    return this.formIncident.get('consequencesSystemId') as UntypedFormControl
  }

  get siteId(){
    return this.formIncident.get('siteId') as UntypedFormControl
  }

  get employeeNumber(){
    return this.formIncident.get('employeeNumber') as UntypedFormControl
  }

  get jefeUN(){
    return this.formIncident.get('headUN') as UntypedFormControl
  }

  get description(){
    return this.formIncident.get('description') as UntypedFormControl
  }

  get address(){
    return this.formIncident.get('address') as UntypedFormControl
  }

  get statusincident(){
    return this.formIncident.get('statusincident') as UntypedFormControl
  }

  get evidenceStatus(){
    return this.formIncident.get('evidenceStatusId') as UntypedFormControl
  }

  get closingDate(){
    return this.formIncident.get('closingDate') as UntypedFormControl
  }

  formIncident = new UntypedFormGroup({
    'invoice': new UntypedFormControl(''),
    'monitoringAdvisor':new UntypedFormControl(''),
    'categoryId':new UntypedFormControl(''),
    'registrationDate':new UntypedFormControl(''),
    'closingDate':new UntypedFormControl(''),
    'typeOfStaffId':new UntypedFormControl(''),
    'rootCauseId':new UntypedFormControl(''),
    'personName':new UntypedFormControl(''),
    'positionId':new UntypedFormControl(''),
    'consequencesSystemId':new UntypedFormControl(''),
    'siteId':new UntypedFormControl(''),
    'employeeNumber':new UntypedFormControl(''),
    'headUN':new UntypedFormControl(''),
    'description':new UntypedFormControl(''),
    'address':new UntypedFormControl(''),
    'statusincident':new UntypedFormControl(''),
    'evidenceStatusId':new UntypedFormControl('')



  });

  constructor(private controltowerservice:ControltowerService,
              private propertiesService:PropertiesTowers,
              private translate:TranslateService,
              private securityService: LoginService) { }

  async ngOnInit(): Promise<void> {

    
  const userName = JSON.parse(localStorage.getItem('ud'))[1].value
  const guid = JSON.parse(localStorage.getItem('guidSession'))
  const response = await this.securityService.login(userName,guid).toPromise()

    this.ud = JSON.parse(localStorage.getItem('ud'))
    console.log('---------------->')

    console.log('obteniendo claims',this.ud[0].value)

    this.formIncident.controls['monitoringAdvisor'].setValue(this.ud[0].value)
  

    this.onClick = this.propertiesService.clickBtnFormIncident.pipe(takeUntil(this.unsubscribe$)).subscribe((value) =>{
      console.log('valor recibido de click en el form',value)
      if(value){
      this.verifyFormIncident(value)
      }
    })

   

    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.lang = s.lang != undefined ? s.lang : "en";
      let succesGeneric = this.getGenericAtrributeValue(this.lang)
    })

    this.lang = this.translate.currentLang != undefined ? this.translate.currentLang : "en";
    if(!this.loadLang){
      let succesGeneric = this.getGenericAtrributeValue(this.lang)
    
    }
    
    this.getSites()

    this.getEventElement()
  }

  onSubmit(){

  }

  getEventElement(){
    this.incidentFormData = []
    this.incidentFormData = JSON.parse(localStorage.getItem('rowSelectEvent'))
    
    console.log('---->',this.incidentFormData)
    console.log('element2',this.incidentFormData)

    this.formIncident.controls['categoryId'].setValue(this.incidentFormData.categoryId)
    this.formIncident.controls['registrationDate'].setValue(this.incidentFormData.registrationDate == null ? null : this.formatDate(this.incidentFormData.registrationDate))
    this.formIncident.controls['typeOfStaffId'].setValue(this.incidentFormData.typeOfStaffId)
    this.formIncident.controls['rootCauseId'].setValue(this.incidentFormData.rootCauseId)
    this.formIncident.controls['personName'].setValue(this.incidentFormData.personName)      
    this.formIncident.controls['positionId'].setValue(this.incidentFormData.positionId)      
    this.formIncident.controls['consequencesSystemId'].setValue(this.incidentFormData.consequencesSystemId)      
    this.formIncident.controls['invoice'].setValue(this.incidentFormData.invoice)  
    this.formIncident.controls['siteId'].setValue(this.incidentFormData.siteId)
    this.formIncident.controls['employeeNumber'].setValue(this.incidentFormData.employeeNumber)
    this.formIncident.controls['address'].setValue(this.incidentFormData.address)
    this.formIncident.controls['headUN'].setValue(this.incidentFormData.headOfUN)
    this.formIncident.controls['description'].setValue(this.incidentFormData.descripcion)
    this.formIncident.controls['statusincident'].setValue(this.incidentFormData.incidentStatus)
    this.formIncident.controls['evidenceStatusId'].setValue(this.incidentFormData.evidenceStatusType == null ? "" : this.incidentFormData.evidenceStatusType.id)
    this.formIncident.controls['closingDate'].setValue(this.incidentFormData.closingDate == null ? null : this.formatDate(this.incidentFormData.closingDate))

   
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  verifyFormIncident(value:number){
    console.log('entre a verify form incident')
    console.log('recibi click',value)

    const isFormValid: boolean = this.formIncident.valid;


    console.log('form incident valido')
    console.log(this.formIncident.value)

    this.formIncidentRequest = this.formIncident.value
    this.formIncidentRequest.eventId = this.incidentFormData.eventId
    this.formIncidentRequest.descripcion = this.incidentFormData.descripcion
    this.formIncidentRequest.locale_Code = this.lang 
    


    this.propertiesService.setDataFormIncident(this.formIncidentRequest,value)

  }


  private async getSites(): Promise<boolean> {


    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSites().subscribe(
        {
          next: (sites: ISitesResponse) => {
   
            this.arraySites = sites.result
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }


  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {
            
            for(let i=0;i<= attribute.attributeTypes.length -1;i++){
              if(attribute.attributeTypes[i].id == 38){
                this.arrayCategorias = attribute.attributeTypes[i].attributeValues

              }
              else if(attribute.attributeTypes[i].id == 40){
                this.arrayTipoPersonal = attribute.attributeTypes[i].attributeValues
              }
              else if(attribute.attributeTypes[i].id == 41){
                this.arrayCausaRaiz = attribute.attributeTypes[i].attributeValues
              }
              else if(attribute.attributeTypes[i].id == 42){
                this.arraySistemaConsecuencias = attribute.attributeTypes[i].attributeValues
              }
              else if(attribute.attributeTypes[i].id == 39){
                this.arrayPuesto = attribute.attributeTypes[i].attributeValues
              }
              else if(attribute.attributeTypes[i].id == 44){
                this.arrayEvidenceStatus =  attribute.attributeTypes[i].attributeValues

              }

            }
           
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  

  ngOnDestroy():void{

    this.onLanChange.unsubscribe()
    this.onClick.unsubscribe()
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
